import React, { useEffect, useRef } from 'react';
import { BookOpen } from 'lucide-react';

// Task #3821 — menu comandi slash del composer PA, costruito ESTENDIBILE:
// oggi implementa solo `/skill` (richiamo esplicito garantito di una skill),
// ma la struttura a `SlashCommandItem` generici è pronta per `/connettore`,
// `/routine`, ecc. (fuori scope qui). Navigazione tastiera: ↑/↓ + Enter/Tab,
// Esc chiude.

export interface SlashCommandItem {
  /** Chiave stabile (per le skill: l'id). */
  id: string;
  /** Testo inserito/mostrato dopo lo slash (per le skill: il nome). */
  label: string;
  description: string;
  /** Namespace del comando (oggi solo 'skill'). */
  kind: 'skill';
  /** Contesto extra mostrato come badge (es. "Team" per le condivise). */
  badge?: string;
}

interface Props {
  items: SlashCommandItem[];
  highlightedIndex: number;
  onHighlight: (index: number) => void;
  onPick: (item: SlashCommandItem) => void;
  /** Query digitata dopo `/` (solo display dell'empty state). */
  query: string;
}

export const SlashCommandMenu: React.FC<Props> = ({ items, highlightedIndex, onHighlight, onPick, query }) => {
  const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = listRef.current?.querySelector<HTMLElement>(`[data-idx="${highlightedIndex}"]`);
    el?.scrollIntoView({ block: 'nearest' });
  }, [highlightedIndex]);

  return (
    <div className="absolute bottom-full left-0 right-0 mb-1 rounded-lg border border-border bg-card shadow-lg overflow-hidden z-30">
      <div className="px-2.5 py-1.5 border-b border-border text-[10px] font-semibold uppercase text-muted-foreground inline-flex items-center gap-1 w-full">
        <BookOpen className="h-3 w-3" /> Skill — procedure disponibili
      </div>
      <div ref={listRef} className="max-h-48 overflow-y-auto py-1">
        {items.length === 0 ? (
          <div className="px-2.5 py-2 text-xs text-muted-foreground">
            {query ? `Nessuna skill per "${query}"` : 'Nessuna skill attiva disponibile'}
          </div>
        ) : items.map((item, idx) => (
          <button
            key={item.id}
            type="button"
            data-idx={idx}
            onMouseEnter={() => onHighlight(idx)}
            // onMouseDown (non onClick): evita il blur della textarea prima del pick
            onMouseDown={(e) => { e.preventDefault(); onPick(item); }}
            className={`w-full text-left px-2.5 py-1.5 flex items-start gap-2 ${idx === highlightedIndex ? 'bg-violet-50' : 'hover:bg-muted'}`}
          >
            <span className="text-xs font-mono font-medium text-violet-700 shrink-0">/skill {item.label}</span>
            {item.badge && (
              <span className="text-[10px] px-1 py-0.5 rounded bg-blue-100 text-blue-700 shrink-0">{item.badge}</span>
            )}
            <span className="text-[11px] text-muted-foreground truncate">{item.description}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
